import React from 'react';

import SciContactImport from '../../components/Admin/SciContactImport';

function SciContactImportView() {
  return (
    <SciContactImport />
  );
}

export default SciContactImportView;
